import { actionTypes } from '../actions';

const initialState = {
  sectors: [],
  loading: false,
  error: false,
};

export default (state = {...initialState}, action) => {
  switch (action.type) {

    case actionTypes.GET_SECTORS_SUCCESS:
      return {
        ...state,
        sectors: action.payload.sectors,
        loading: false,
        error: false,
      };
    case actionTypes.GET_SECTORS_REQUSET:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actionTypes.GET_SECTORS_FAILURE:
      return {
        sectors: [],
        loading: false,
        error: true,
      };
    case actionTypes.LOGGED_OFF:
      return { ...initialState };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./reducers/sectors.js